/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_all_assessment_kits_data_action } from "../../../redux/_actions";
import { showSuccessMessage } from "../../../_uiComponents/ShowMessageSnack";
import { appRoutes } from "../../../_routes/app-routes";
function useAssessmentList() {
  const [loading, setLoading] = useState(false);
  const [allAssessmentKits, setAllAssessmentKits] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("Published");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const outerClickRef = useRef();

  const { allPublishedAssessmentData } = useSelector(
    (state) => state.get_all_assessment_kits_data_reducer
  );

  useEffect(() => {
    getAssessmentKits("publish");
  }, []);

  useEffect(() => {
    if (allPublishedAssessmentData) {
      setAllAssessmentKits(allPublishedAssessmentData);
    }
  }, [allPublishedAssessmentData]);

  const getAssessmentKits = async (type) => {
    setLoading(true);
    await dispatch(get_all_assessment_kits_data_action(type));
    setLoading(false);
  };

  const onViewCandidatesClick = (interviewKit) => {
    navigate(
      appRoutes.assessementKit.viewCandidates.replace(":id", interviewKit)
    );
  };

  const onEditKitClick = (id) => {
    navigate(appRoutes.assessementKit.viewAssessment.replace(":id", id));
  };

  const onClickNewAssessment = () => {
    navigate(appRoutes.assessementKit.createAssessment);
  };

  const onAssessmentShareClick = (hash_id) => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";

    if (hash_id) {
      const url = isDev
        ? `http://localhost:3000${appRoutes.assessementKit.assessmentPublicDetails.replace(
            ":id",
            hash_id
          )}`
        : `${
            process.env.REACT_APP_DEV_ROOT_URL
          }${appRoutes.assessementKit.assessmentPublicDetails.replace(
            ":id",
            hash_id
          )}`;
      window.navigator.clipboard.writeText(url);

      showSuccessMessage(`Url copied ${url}`);
    }
  };

  const handleFilterChange = (type, selectedFilterName) => {
    setSelectedFilter(selectedFilterName);
    getAssessmentKits(type);
    outerClickRef.current.click();
  };
  return {
    loading,
    allAssessmentKits,
    selectedFilter,
    outerClickRef,
    handleFilterChange,
    onEditKitClick,
    onViewCandidatesClick,
    onClickNewAssessment,
    onAssessmentShareClick,
  };
}
export default useAssessmentList;
